export default () => ({
    comercios: []
})